export const PRODUCT = {
  HOME: 'product',
}
